declare const window: any;

interface IAppSettings {
	lang: string;
	email: string;
	resourcePrefix: string;
	raygunApiKey: string;
	applicationVersion: string;
	timezone: string;
	roles: string[];
}

export const AppSettings: IAppSettings = window.AppSettings || {};

